import {ProductDataService} from "../../services/productDataService";
import {AppStateService} from "../../services/appStateService";

export class DrawingOptionsService {
    private productDataService: ProductDataService;
    private appStateService: AppStateService;

    constructor() {
        this.productDataService = new ProductDataService();
        this.appStateService = new AppStateService();
    }

    getDefaultDrawingOptions()
    {
        let mullionObject = {};

        if (this.appStateService.getAppSettingOption('allowToMoveMullions')) {
            mullionObject = {
                buttons: [{
                    positions: ['rect'],
                    onMove: (response) => {
                        this.productDataService.updateMullionPosition(response.mullion, response.position)
                    },
                }],
            };
        }
        return {
            dimensions: {
                multiplier: 1,
                ratio: 1,
                type: 'inner',
            },
            mullion: mullionObject,
            base: {side: 'inner'}
        };
    }

}
